<template>
  <BlockTypeHeading v-if='type=="heading"' :block='block' />
  <BlockTypeText v-if='type=="text"' :block='block' />
  <BlockTypeVideo v-if='type=="video"' :block='block' />
  <BlockTypeImage v-if='type=="customimage"' :block='block' :context='context' />
</template>

<script setup>
const props = defineProps({
  block: {
    type: Object,
    required: true,
    default: {}
  },
  context: {
    type: Object,
    required: false,
    default: {}
  },
  filter: {
    type: [String, Boolean],
  }
});
const type = computed(()=> props.block.type);
</script>
